module.exports = __webpack_public_path__ + "img/Prins-Bernhard-Cultuurfonds-liggend.2f4f228c.svg";